/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Sections_MessageInputs */

const fr_no_sections_message = /** @type {(inputs: No_Sections_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune section configurée. Ajoutez une section pour commencer.`)
};

/**

* @param {No_Sections_MessageInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const no_sections_message = /** @type {((inputs?: No_Sections_MessageInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Sections_MessageInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_no_sections_message(inputs)
});